module.exports = __webpack_public_path__ + "static/img/wz-open-tit.5ed3935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wz-open-tit.png
// module id = /kCK
// module chunks = 1